module.exports = __webpack_public_path__ + "img/lightmode_cross.67786d26.png";